import { ApplicationController } from "../application_controller"

export default class extends ApplicationController {
    initialize() {}

    connect() {}

    destroy() {}

    meta_facebook_login(e) {
	e.preventDefault()

	var width = 600
	var height = 680 // Slightly taller to account for your own branding/header
	var left = (window.screen.width / 2) - (width / 2)
	var top = (window.screen.height / 2) - (height / 2)

	window.open(`${e.target.getAttribute('href')}`, 'FBLogin', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`)

	window.addEventListener('message', (event) => {
	    if (event.origin !== `https://${e.target.getAttribute('data-app-allowed-domain')}`) return
	    
  	    var element = this.element.querySelector(".connection-data-system-integrations-url")
  	    element.dataset.params = `authorization_code=${event.data.code}&waba_id=${event.data.waba_id}&phone_number_id=${event.data.phone_number_id}`
	    console.log(`authorization_code=${event.data.code}&waba_id=${event.data.waba_id}&phone_number_id=${event.data.phone_number_id}`)
  	    element.click()
	})
    }
}
